import type { FunctionComponent, MouseEventHandler } from 'react';
import { useCallback } from 'react';

import { Analytics, formatContainers } from '@trello/atlassian-analytics';
import { intl } from '@trello/i18n';
import { Button } from '@trello/nachos/button';
import { AddIcon } from '@trello/nachos/icons/add';
import { PopoverPlacement, usePopover } from '@trello/nachos/popover';

import { CreateBoardPopover } from 'app/src/components/CreateBoardPopover';

interface CreateBoardButtonProps {
  workspaceId: string;
}

export const CreateBoardButton: FunctionComponent<CreateBoardButtonProps> = ({
  workspaceId,
}) => {
  const { triggerRef, toggle, show, hide, popoverProps, push, pop } =
    usePopover({
      placement: PopoverPlacement.RIGHT_START,
    });

  const newBoard = useCallback<MouseEventHandler>(() => {
    Analytics.sendClickedButtonEvent({
      buttonName: 'createBoardButton',
      source: 'boardSwitcherModal',
      containers: formatContainers({
        workspaceId,
      }),
    });

    toggle();
  }, [toggle, workspaceId]);

  return (
    <>
      <Button
        ref={triggerRef}
        onClick={newBoard}
        iconBefore={<AddIcon />}
        appearance="subtle"
        title={intl.formatMessage({
          id: 'templates.board_switcher.create',
          defaultMessage: 'Create',
          description: 'Title on create board button',
        })}
      />
      <CreateBoardPopover
        preSelectedWorkspaceId={workspaceId}
        analyticsSource="boardSwitcherModal"
        show={show}
        hide={hide}
        pop={pop}
        push={push}
        popoverProps={popoverProps}
      />
    </>
  );
};
